/** Fields of a palette item that local search matches against. */
export interface MatchableItem {
    label: string
    keywords?: string[]
}

/**
 * Ranks how well an item matches a search term: 0 when the label starts with it, 1 when a word in the label does,
 * 2 when the label contains it anywhere and 3 when only a keyword does. Undefined means no match.
 */
export function paletteMatchRank(item: MatchableItem, term: string): number | undefined {
    const needle = term.trim().toLowerCase()
    if (!needle) return undefined
    const label = item.label.toLowerCase()
    if (label.startsWith(needle)) return 0
    const position = label.indexOf(needle)
    if (position > 0) return /[\s›/(-]/.test(label[position - 1]) ? 1 : 2
    if (item.keywords?.some((keyword) => keyword.toLowerCase().includes(needle))) return 3
    return undefined
}

/** Returns the items matching the term, best matches first and otherwise in their original order. */
export function filterPaletteItems<T extends MatchableItem>(items: T[], term: string): T[] {
    return items
        .map((item, index) => ({ item, index, rank: paletteMatchRank(item, term) }))
        .filter((entry): entry is { item: T; index: number; rank: number } => entry.rank !== undefined)
        .sort((a, b) => a.rank - b.rank || a.index - b.index)
        .map((entry) => entry.item)
}
